module.exports = __webpack_public_path__ + "static/media/report_wouldnt_mention_white.eb956026.svg";